/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.sendMessageBatch'

export { $nsid }

const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    items: l.array(l.ref<BatchItem>((() => batchItem) as any), {
      maxLength: 100,
    }),
  }),
  l.jsonPayload({
    items: l.array(
      l.ref<ConvoDefs.MessageView>((() => ConvoDefs.messageView) as any),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output

type BatchItem = {
  $type?: 'chat.bsky.convo.sendMessageBatch#batchItem'
  convoId: string
  message: ConvoDefs.MessageInput
}

export type { BatchItem }

const batchItem = l.typedObject<BatchItem>(
  $nsid,
  'batchItem',
  l.object({
    convoId: l.string(),
    message: l.ref<ConvoDefs.MessageInput>(
      (() => ConvoDefs.messageInput) as any,
    ),
  }),
)

export { batchItem }
